import React, {Component, createContext} from "react";

const EntiteContext = createContext();

export const EntiteConsumer = EntiteContext.Consumer;

class EntiteProvider extends Component {
    state = {
        idGroup: 2151,
        selectedCharts: [],
        architecture: ["testt"],
    };

    setIdGroup = (idGroup) => {
        this.setState((prevState) => ({idGroup}));
    };

    setSelectedCharts = (selectedCharts) => {
        this.setState((prevState) => ({selectedCharts}));
    };

    setArchitecture = (architecture) => {
        this.setState((prevState) => ({architecture}));
    }

    render() {
        const {children} = this.props;
        const {idGroup, selectedCharts,architecture} = this.state;
        const {setIdGroup, setSelectedCharts,setArchitecture} = this;
        return (
            <EntiteContext.Provider
                value={{
                    idGroup,
                    setIdGroup,
                    selectedCharts,
                    setSelectedCharts,
                    architecture,
                    setArchitecture
                }}
            >
                {children}
            </EntiteContext.Provider>
        );
    }
}

export default EntiteContext;

export {EntiteProvider};
